// Lib
import { AnyAction, Reducer, combineReducers } from 'redux';

// Reducers
import Account from './account';
import AIContext from './aiContext';
import AISession from './aiSession';
import SelectedOrganization from './selectedOrganization';
import User from './user';
import FormErrors from './formErrors';
import isLoading from './loading';
import isPreview from './preview';
import redirectControl from './redirectControl';
import Feed from './feed';
import Toast from './toast';
import Popup from './popup';
import Drawer from './drawer';
import Users from './users';
import Posts from './posts';
import Search from './search';
import Slides from './slides';
import Subscription from './subscription';
import Products from './products';
import Campaign from './campaign';

const appReducer = combineReducers({
  Account,
  AIContext,
  AISession,
  SelectedOrganization,
  User,
  FormErrors,
  isLoading,
  redirectControl,
  isPreview,
  Feed,
  Toast,
  Popup,
  Drawer,
  Users,
  Posts,
  Search,
  Slides,
  Subscription,
  Products,
  Campaign,
});

export type RootState = ReturnType<typeof appReducer>;

interface LogoutAction extends AnyAction {
  type:
    | 'ACCOUNT_LOGOUT'
    | 'ACCOUNT_LOGOUT_TO_LOGIN'
    | 'MARBLE_USER_LOGOUT'
    | 'SESSION_RESET';
}

/**
 * Actions that drop the whole store back to its initial state.
 *
 * `SESSION_RESET` is the saga-free member of the set: the three logout actions
 * are each watched by a saga that navigates the browser away, while
 * `SESSION_RESET` only clears state so a different account can be loaded in
 * place (token-based sign-in — see `useTokenLogin`).
 */
const LOGOUT_ACTIONS = [
  'ACCOUNT_LOGOUT',
  'ACCOUNT_LOGOUT_TO_LOGIN',
  'MARBLE_USER_LOGOUT',
  'SESSION_RESET',
] as const;

const rootReducer: Reducer<RootState, AnyAction> = (
  state: RootState | undefined,
  action: AnyAction,
): RootState => {
  if (LOGOUT_ACTIONS.includes(action.type as (typeof LOGOUT_ACTIONS)[number])) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
